$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  const target = $(href == '#' || href == '' ? 'html' : href);
  const spt = parseInt($('html').css('scrollPaddingTop')) || 0;
  const smt = parseInt($(target).css('scrollMarginTop')) || 0;
  // スクロール先
  const position = target.offset().top - (spt + smt);
  $('html, body').animate({ scrollTop: position }, speed, easing);
  return false;
});

// 外部リンクのアニメーション
var urlHash = location.hash;
var headerHeight = $('.header').outerHeight(true);
if (urlHash) {
  $('body,html').stop().scrollTop(0);
  setTimeout(function() {
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
  }, 100);
}

// SP nav
$(document).ready(function () {

  // ハンバーガー開閉
  $('.js-nav-bt').on('click', function (e) {
    e.stopPropagation();
    $('.js-nav-content, .js-nav-logo, .js-nav-bt')
      .toggleClass('is-navOn');
  });

  // SPのときだけ、リンクを押したら閉じる
  $('.js-nav-bt.is-navOn, .js-nav-logo.is-navOn, .js-nav-link')
  .not('.is-subLink .js-nav-link')
  .on('click', function (e) {

    if (window.innerWidth <= 768) {
      $(".js-nav-content, .js-nav-logo, .js-nav-bt")
        .removeClass('is-navOn');
    }
});
});

if (window.matchMedia("(max-width: 768px)").matches) {
  $('.is-subLink > .js-nav-link').on('click', function(e){

  e.preventDefault();
  e.stopPropagation();

  const $parent = $(this).closest('.is-subLink');
  const $sub = $parent.find('.subLink');
  const $plus = $parent.find('.js-sp-navDown');

  $('.subLink').not($sub).slideUp();
  $('.js-sp-navDown').not($plus).removeClass('is-on');

  $sub.stop(true, true).slideToggle();
  $plus.toggleClass('is-on');

});

  $(function () {
    $(window).on("scroll", function () {
      const sliderHeight = $(".topMv").height();
      if (sliderHeight - 30 < $(this).scrollTop()) {
        $(".js-header-sp").addClass("is-headerOn");
      } else {
        $(".js-header-sp").removeClass("is-headerOn");
      }
    });
  });

  $(function () {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $(".js-footer-sp").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(".js-cv-sp").addClass("is-none");
      } else {
        $(".js-cv-sp").removeClass("is-none");
      }
    });
  });

  jQuery(function($) {
    $('.js-sp-navDown').on('click', function (e) {

      e.preventDefault();
      e.stopPropagation();

      const $sub = $(this).next();

      $('.subLink').not($sub).slideUp();
      $('.js-sp-navDown').not(this).removeClass('is-on');

      $sub.stop(true, true).slideToggle();
      $(this).toggleClass('is-on');
    });
  });


}

jQuery(function($) {
  //tab
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });
});
